var map = {
	"./tech-apache-airflow.svg": 2096,
	"./tech-excel.svg": 2097,
	"./tech-git.svg": 2098,
	"./tech-google-sheets.svg": 2099,
	"./tech-gray-chatgpt.svg": 1326,
	"./tech-gray-excel.svg": 1327,
	"./tech-gray-git.svg": 1328,
	"./tech-gray-google-sheets.svg": 1329,
	"./tech-gray-jupyter.svg": 1330,
	"./tech-gray-multiple.svg": 1331,
	"./tech-gray-other.svg": 1332,
	"./tech-gray-powerbi.svg": 1333,
	"./tech-gray-python.svg": 1334,
	"./tech-gray-r.svg": 1335,
	"./tech-gray-sql.svg": 1336,
	"./tech-gray-tableau.svg": 1337,
	"./tech-gray-theory.svg": 1338,
	"./tech-powerbi.svg": 2100,
	"./tech-python (2).svg": 2101,
	"./tech-python.svg": 2102,
	"./tech-r.svg": 2103,
	"./tech-responsive-apache-airflow.svg": 1284,
	"./tech-responsive-artificial-intelligence.svg": 591,
	"./tech-responsive-chatgpt.svg": 1285,
	"./tech-responsive-data.svg": 1286,
	"./tech-responsive-excel.svg": 1287,
	"./tech-responsive-git.svg": 1288,
	"./tech-responsive-google-sheets.svg": 1289,
	"./tech-responsive-jupyter.svg": 1290,
	"./tech-responsive-langchain.svg": 1291,
	"./tech-responsive-multiple.svg": 1292,
	"./tech-responsive-powerbi.svg": 1293,
	"./tech-responsive-powerpoint.svg": 1294,
	"./tech-responsive-python.svg": 1295,
	"./tech-responsive-r.svg": 1296,
	"./tech-responsive-sql.svg": 1297,
	"./tech-responsive-tableau.svg": 1298,
	"./tech-responsive-theory.svg": 1299,
	"./tech-sql.svg": 2104,
	"./tech-tableau.svg": 2105,
	"./tech-theory.svg": 2106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4136;